import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useAppContext } from '@app-velocity/config';
import { MessageBus } from '@app-velocity/message-bus';
import { useGetTeamsQuery } from '@app-velocity/libs/teams-data-access';

const messageBus = new MessageBus('users');

const teamBillingPath = (teamId: string, workspaceId: string) =>
  `/${teamId}/${workspaceId}/admin/billing`;

export const useOpenTeamBilling = (teamId: string, workspaceId: string) => {
  const navigate = useNavigate();
  const { AVMLink } = useAppContext();
  const { data: teams } = useGetTeamsQuery();

  const team = teams?.find((item) => item.teamId === teamId);
  const hasAccessToBilling = team?.userRole === 'OWNER';

  const openBilling = useCallback(() => {
    if (!teams || !teamId || !workspaceId) return;

    if (!hasAccessToBilling) {
      messageBus.publish('modal:contact-team-admin:open');

      return;
    }

    const path = teamBillingPath(teamId, workspaceId);

    if (AVMLink) {
      window.open(`${AVMLink}${path}`, '_blank');

      return;
    }

    navigate(path);
  }, [AVMLink, hasAccessToBilling, navigate, teamId, teams, workspaceId]);

  return {
    hasAccessToBilling,
    openBilling,
  };
};
